import {BusinessLocation, CurrentUser} from "../../types/Types";
import {useNavigate} from "react-router";
import {default as React, useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBeerMugEmpty, faUtensils} from "@fortawesome/free-solid-svg-icons";
import {collection, getDocs, limit, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import DisplayListControl from "../list/DisplayListControl";
import { cityColour } from "../../utils/Utils";

interface Props {
  currentUser: CurrentUser | undefined,
  businessId: string | undefined,
  defaultDisplayList: boolean,
}

function BusinessLocationList(props: Props) {
  const navigate = useNavigate();
  const [displayList, setDisplayList] = useState<boolean>(props.defaultDisplayList);
  const [locations, setLocations] = useState<Array<BusinessLocation>>([]);

  useEffect(() => {(async () => {
    let locations = new Array<BusinessLocation>();
    const locationsCollection = query(
        collection(db, 'locations'),
        where("business", "==", props.businessId),
        limit(200),
    );
    const locationsSnapshot = await getDocs(locationsCollection);
    locationsSnapshot.forEach((doc) => {
      locations.push(doc.data() as BusinessLocation);
    });
    setLocations(locations);
  })();
  }, []);

  if(!props.currentUser) {
    return <></>
  }

  return (
      <div className={"mb-3"}>
        <div className={`list-title ${displayList ? "" : "mb-0"}`} onClick={() => setDisplayList(!displayList)}>
          <b>Locations</b>
          <DisplayListControl displayList={displayList} count={undefined} />
        </div>
        {displayList && locations.map((location, index) => (
            <div className={`basic-box colour-secondary cursor-pointer ${index == locations.length-1 ? 'mb-0' : 'mb-2'}`} onClick={() => navigate(`/location/${location.id}`)}>
              <div className={"font-md font-weight-500"}>{location.address}</div>
              <div className={"font-md d-inline-block"}>
                <div className={"tag me-1"} style={{backgroundColor: cityColour(location.city)}}>{location.city}</div>
                <div className={"tag grey"}>{location.country}</div>
                {location.typeTags.sellsFood && <div className={"d-inline-block ms-1"}><FontAwesomeIcon icon={faUtensils}/></div>}
                {location.typeTags.sellsAlcohol && <div className={"d-inline-block ms-1"}><FontAwesomeIcon icon={faBeerMugEmpty}/></div>}
              </div>
              <div className={"tag green float-right"} style={{marginTop: "5px"}}>{location.status}</div>
            </div>
        ))}
      </div>
  )
}

export default BusinessLocationList;